import React from 'react'
import styled, { keyframes, css } from 'styled-components'
import { useInView } from 'react-intersection-observer';

const FadeInContent = (props) => {
  const { ref, inView, entry } = useInView();
  return (
    <Root ref={ref} isVisible={inView}>
      {props.children}
    </Root>
  )
}

const slideIn = keyframes`
  0% {
    opacity: 0;
    transform: translate3d(0, 40px, 0);
  }

  10% {
    opacity: 0;
    transform: translate3d(0, 40px, 0);
  }

  90% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }

  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;

const animateSlideIn = css`
  animation: ${slideIn};
  animation-duration: 1s;
  animation-fill-mode: backwards;
  animation-timing-function: ease-in-out;
  animation-iteration-count: 1;
`;
const Root = styled.div`
    ${props => props.isVisible ? animateSlideIn : 'opacity: 0'}; 
`;
export default FadeInContent